// undefined is not included here since Array.prototype.sort does treat undefined array entries
// like other entries. undefined entries will always be sorted last. This likely doesn't affect
// sorting array of objects that have undefined sort keys but it does affect array where the
// element itself is the sort key. Having it work in one scenario but not the other would produce
// inconsistent sorts.

/**
 * Common options for comparators
 */

export const addDefaults = o => {
  return {
    direction: 'ascending',
    sensitivity: 'strict',
    toSortKey: t => typeof t === 'number' ? t : String(t),
    ...o
  };
};
//# sourceMappingURL=types.js.map